export interface AccountStatementDTO {

}
